import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
  import { t } from '@/ui/i18n/i18n';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TranslationTooltip',
  props: {
    active: Boolean,
    isAi: {
      type: Boolean,
      default: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const label = computed(() => props.isAi
    ? t('template-builder.translations.ai-view-banner')
    : t('template-builder.translations.manual-view-banner'));

return { __sfc: true,props, label }
}

})